import * as React from "react";
import { FvcAnalysisSet, FvcSession } from "webportalclient";
import { NextGenFixedCommentSelectors } from "../Spirometry/Testing/NextGenFixedCommentSelectors";
import { ToggleSessionFixedCommentsVisibilityAction, NextGenFixedCommentsState, ToggleTestFixedCommentsVisibilityAction, ToggleSessionFixedCommentCheckedAction, ToggleTestFixedCommentCheckedAction } from "../Spirometry/Testing/UseNextGenFixedComments";
import { DynamicResultsGroupHeading } from "./ResultsGroupHeading";

interface OverreadingResultsCommentsProps {
    session: FvcSession;
    viewOnly: boolean;
    fixedCommentsStateOverreading: NextGenFixedCommentsState;
    fixedCommentsDispatchOverreading;
    fixedCommentsStateTechnician: NextGenFixedCommentsState;
    fixedCommentsDispatchTechnician;
}

export const OverreadingResultsComments = ({ session, viewOnly, fixedCommentsStateOverreading, fixedCommentsDispatchOverreading, fixedCommentsStateTechnician, fixedCommentsDispatchTechnician }: OverreadingResultsCommentsProps) => {
    return (
        <>
            <DynamicResultsGroupHeading resultsCount={session.tests.length} title="Comments" />
            <NextGenFixedCommentSelectors
                headerPrefix="Technician"
                editable={false}
                sessionFixedComments={fixedCommentsStateTechnician.sessionFixedComments}
                testFixedComments={fixedCommentsStateTechnician.testFixedComments}
                onSessionFixedCommentClick={() => fixedCommentsDispatchTechnician(ToggleSessionFixedCommentsVisibilityAction.create())}
                onTestFixedCommentClick={testId => fixedCommentsDispatchTechnician(ToggleTestFixedCommentsVisibilityAction.create(testId))}
                session={session}
                handleSessionChange={null}
                handleTestChange={(testId, commentId, checked) => fixedCommentsDispatchTechnician(ToggleTestFixedCommentCheckedAction.create(testId, commentId, checked))}
                handleSessionClose={() => fixedCommentsDispatchTechnician(ToggleSessionFixedCommentsVisibilityAction.create())}
                handleTestClose={(testId) => fixedCommentsDispatchTechnician(ToggleTestFixedCommentsVisibilityAction.create(testId))}
            />
            <NextGenFixedCommentSelectors
                headerPrefix="Overreading"
                editable={!viewOnly}
                sessionFixedComments={fixedCommentsStateOverreading.sessionFixedComments}
                testFixedComments={fixedCommentsStateOverreading.testFixedComments}
                onSessionFixedCommentClick={() => fixedCommentsDispatchOverreading(ToggleSessionFixedCommentsVisibilityAction.create())}
                onTestFixedCommentClick={testId => fixedCommentsDispatchOverreading(ToggleTestFixedCommentsVisibilityAction.create(testId))}
                session={session}
                handleSessionChange={(commentId, checked) => fixedCommentsDispatchOverreading(ToggleSessionFixedCommentCheckedAction.create(commentId, checked))}
                handleTestChange={(testId, commentId, checked) => fixedCommentsDispatchOverreading(ToggleTestFixedCommentCheckedAction.create(testId, commentId, checked))}
                handleSessionClose={() => fixedCommentsDispatchOverreading(ToggleSessionFixedCommentsVisibilityAction.create())}
                handleTestClose={(testId) => fixedCommentsDispatchOverreading(ToggleTestFixedCommentsVisibilityAction.create(testId))}
            />
        </>
    );
}
